import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import {
  DEFAULT_PRACTICAL_INFO,
  adresseCanonique,
  schemaDeLEtablissement,
} from '@azoya-spa/contracts'
import { useSiteContent } from '../hooks/useSiteContent'

/*
 * Pose le balisage Schema.org de l'établissement dans le `<head>`
 * (issue #146). L'audit SEOptimer n'en détectait aucun.
 *
 * Les données viennent de `practical-info`, la même source que le pied de
 * page : un schéma qui recopierait l'adresse ou le téléphone deviendrait faux
 * au premier changement fait depuis le back-office, et la page dirait alors
 * deux choses différentes — l'une aux visiteurs, l'autre aux moteurs.
 *
 * MÊME LIMITE QUE `useMetadonnees` : ce script est écrit par JavaScript.
 * Google rend le JavaScript et le lit, les crawlers de LLM qui s'arrêtent au
 * HTML brut ne le verront pas. Le prérendu (issue #149) est ce qui lèvera la
 * limite. Le poser en dur dans `index.html` aurait été l'autre voie, mais au
 * prix d'un schéma figé à la compilation — c'est-à-dire faux dès que la
 * gérante change un numéro.
 */

const ID = 'schema-etablissement'

export function useDonneesStructurees() {
  const { pathname } = useLocation()
  const info = useSiteContent('practical-info', DEFAULT_PRACTICAL_INFO)

  useEffect(() => {
    // Une entité unique, décrite une seule fois, sur la page qui la
    // représente. La répéter sur chaque page ne l'affirme pas davantage, et
    // multiplie les occasions de se contredire.
    const surLAccueil = adresseCanonique(pathname) === '/'

    document.getElementById(ID)?.remove()
    if (!surLAccueil) return

    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.id = ID
    script.textContent = JSON.stringify(schemaDeLEtablissement(info))
    document.head.appendChild(script)

    // Le nettoyage vaut aussi pour le démontage, pas seulement pour le
    // changement de page : sans lui, un script survivrait au retrait du
    // composant et décrirait une page qui n'est plus là.
    return () => document.getElementById(ID)?.remove()
  }, [pathname, info])
}
